import NameId from '../Models/NameId';

export function isIdInNameIdArray(id:string,nameIds:NameId[] | undefined):boolean{
  if(nameIds === undefined){
    return false;
  }
  return nameIds.some(nameId => nameId.id === id);
}